import mehrfamilienImg from '@/assets/icons/images/teaser_mehrfamilien.jpg';
import energieberatungImg from '@/assets/icons/images/teaser_energieberatung.jpg';
import solarImg from '@/assets/icons/images/teaser_solar.jpg';

const teaserCardsData = [
    {
        id: "teaser-energie",
        imageSrc: energieberatungImg,
        imageAlt: 'Ein Mann und eine Frau sitzen mit einer Energieberaterin an einem Tisch, besprechen Unterlagen und schauen auf ein Tablet.',
        headline: 'Energieberatung für Häuser älter als 10 Jahre',
        text: 'Das Energieberatungspaket unserer Partner für die energetische Modernisierung Ihres Hauses',
        buttonText: 'Energieberatung',
        buttonLink: 'https://www.vattenfall.de/waerme/energieberatung'
    },
    {
        id: "teaser-solar",
        imageSrc: solarImg,
        imageAlt: 'Ein Mann steht neben einem großen Solarmodul, lächelt und hält ein Tablet in der Hand.',
        headline: 'Solarstrom einfach selbst erzeugen',
        text: 'Bis zu 80% des Strombedarfs ihres Hauses decken und unabhängiger von steigenden Strompreisen werden.',
        buttonText: 'PV-Komplettanlage',
        buttonLink: 'https://www.vattenfall.de/solar/pv-komplettanlage'
    },
    {
        id: "teaser-mehfamilien",
        imageSrc: mehrfamilienImg,
        imageAlt: 'Moderne, weiße Mehrfamilienhäuser mit Balkonen und begrüntem Innenhof bei sonnigem Wetter.',
        headline: 'Wärmelösungen für Mehrfamilienhäuser',
        text: 'Mit individuellen Wärmelosungen unterstützt Vattenfall bei der Modernisierung und Dekarbonisierung von Gebäudebeständen.',
        buttonText: 'Mehr erfahren',
        buttonLink: 'https://www.vattenfall.de/b2b-waermeloesungen',
        //ariaDescribedById: "insulationTeaserFootnote",
    }
];

export default teaserCardsData;